import { httpRequest } from "@services/http";
import { Credit } from "@models/credit.model";
import { CreditSerializer } from "@models/serializers/creditSerializer";

export class CommandDeleteCredit {
  async run(contractId: number, creditId: number): Promise<Credit> {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/finance/contracts/${contractId}/credits/${creditId}/`;
    const response = await httpRequest<any>(url, { method: "DELETE" });
    return CreditSerializer.fromJson(response);
  }
}
